import { useEffect, useState } from 'react'
import { formatDateHourMinutes } from 'util/date/formatDate'

import { useServerTime } from './useServerTime'

export function useClock(interval: number = 1000): string {
  const { getServerTimeNow } = useServerTime()
  const [time, setTime] = useState<string>(() => formatDateHourMinutes(getServerTimeNow()))

  useEffect(() => {
    const timer = setInterval(() => {
      const date = getServerTimeNow()
      const newTime = formatDateHourMinutes(date)
      setTime((prev) => {
        if (prev !== newTime) {
          return newTime
        }
        return prev
      })
    }, interval)

    return () => clearInterval(timer)
  }, [interval, getServerTimeNow])

  return time
}
